// ============================================
// Settings - State (Zustand 기반)
// ============================================
// 이 파일은 하위 호환성을 위해 유지됩니다.
// 새 코드에서는 stores/settingsStore.js에서 직접 import하세요.
// ============================================

import { useSettingsStore } from '../../stores/settingsStore.js';
import { useAppStore } from '../../stores/appStore.js';

// ============================================
// Model Getters & Setters
// ============================================

export function getSelectedModel() {
  return useSettingsStore.getState().selectedModel;
}

export function setSelectedModel(model) {
  useSettingsStore.getState().setSelectedModel(model);
}

// ============================================
// Profile Selection State
// ============================================

export function getSelectedProfileForChange() {
  return useSettingsStore.getState().selectedProfileForChange;
}

export function setSelectedProfileForChange(profileId) {
  useSettingsStore.getState().setSelectedProfileForChange(profileId);
}

export function isInlineProfileSelectorOpen() {
  return useSettingsStore.getState().inlineProfileSelectorOpen;
}

export function setInlineProfileSelectorOpen(open) {
  useSettingsStore.getState().setInlineProfileSelectorOpen(open);
}

export function getInlineSelectedGender() {
  return useSettingsStore.getState().inlineSelectedGender;
}

export function setInlineSelectedGender(gender) {
  useSettingsStore.getState().setInlineSelectedGender(gender);
}

// ============================================
// Load Settings from Chat Data
// ============================================

export function loadSettings() {
  const chatData = useAppStore.getState().currentChatData;
  if (chatData?.settings) {
    useSettingsStore.getState().loadFromChatData(chatData);
  }
}

// ============================================
// Settings UI Updates
// ============================================

export function updateModelSetting(value) {
  useSettingsStore.getState().setSelectedModel(value);
}
